import React from "react";

const InputInfoMessage = ({ message }) => (
  <div className="input__info-message">{message}</div>
);

export default InputInfoMessage;
